import {
  Wallet,
  Calendar,
  User,
  Building2,
  MessageCircleIcon
} from "lucide-react";
import { navigate } from "wouter/use-browser-location";
import { cn } from "@/lib/utils";
import { useNavigationTabs } from "@/hooks/use-navigation-tabs";
import { usePosCartGuard } from "@/providers/PosCartGuardProvider";
import ConfirmModal from "./ConfirmationModal";
import { useState } from "react";

const tabs = [
  { id: "wallet", label: "Wallet", icon: Wallet, href: "/" },
  { id: "menu", label: "Services", icon: Building2, href: "/menu" },
  { id: "events", label: "Events", icon: Calendar, href: "/events" },
  { id: "chat", label: "Chat", icon: MessageCircleIcon, href: "/chat" },
  { id: "account", label: "Account", icon: User, href: "/account" }
];

const NavigationTabs = () => {
  const { location } = useNavigationTabs();
  const { posHasItems } = usePosCartGuard();
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingHref, setPendingHref] = useState<string | null>(null);

  const handleTabClick = (href?: string) => {
    const isLeavingPOS =
      location.startsWith("/menu") &&
      href &&
      !href.startsWith("/menu") &&
      posHasItems;

    if (isLeavingPOS) {
      setPendingHref(href || null);
      setShowConfirm(true);
      return;
    }

    if (href) navigate(href);
  };

  return (
    <div className="app-tabs-btm">
      <div className="flex items-center gap-1 bg-[#2f2f32] rounded-full border border-[#4D4D4D] p-1 w-fit shadow-lg max-w-[1024px] mx-auto">
        {tabs.map(({ id, label, icon: Icon, href }) => {
          const isActive = href === "/"
            ? location === "/"
            : location.startsWith(href);

          return (
            <button
              key={id}
              onClick={() => handleTabClick(href)}
              className={cn(
                "flex items-center rounded-full px-4 py-2 transition-all duration-300 ease-in-out",
                isActive
                  ? "bg-[#1A1313] text-[#dc2626] gap-2"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              )}
            >
              <Icon
                size={16}
                className={cn(
                  "shrink-0 transition-all duration-300 ease-in-out",
                  isActive ? "w-4 h-4 opacity-100" : "w-0 opacity-0"
                )}
              />

              <span className="whitespace-nowrap">{label}</span>
            </button>
          );
        })}
        <ConfirmModal
          open={showConfirm}
          title="Your order isn’t complete"
          description="Leaving this page will remove all items from your cart."
          confirmText="Leave anyway"
          cancelText="Stay"
          variant="logout"
          onClose={() => {
            setShowConfirm(false);
            setPendingHref(null);
          }}
          onConfirm={() => {
            if (pendingHref) {
              navigate(pendingHref);
            }
            setShowConfirm(false);
            setPendingHref(null);
          }}
        />
      </div>
    </div>
  );
};

export default NavigationTabs;
